import { Grid, TextInput, Select, Badge, Tooltip } from '@mantine/core';
import React from 'react';
import B2BButton from '../components/common/B2BButton';
import { useMediaQuery } from '@mantine/hooks';

const SalesHeader = ({ buttonArr, fields }) => {
      const isMobile = useMediaQuery("(max-width: 767px)");
    return (
        <div style={{ padding: '10px' }}>
            <Grid
                style={{
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#c9e8b8",
                    padding: '15px 18px',
                    borderRadius: '4px',
                    gap: '15px',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%',flexDirection: isMobile ? 'column' : 'row' }}>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
                        {fields?.map((field, index) => (
                            <div key={index}>
                                {field.type === 'B2BSelect' ? (
                                    <div style={{ display: 'flex', textAlign: 'center', gap: '0.5rem' }}>
                                        <label style={{ display: "flex", alignItems: 'center' }}>
                                            <strong >{field.label}:</strong>
                                        </label>
                                        <Select
                                            placeholder={field.placeholder}
                                            data={field.data}
                                            value={field.value}
                                            onChange={field.onChange}
                                            disabled={field.disabled}
                                            variant="Default"
                                            styles={{
                                                input: {
                                                    borderBottom: '2px solid lightgray',
                                                    textDecoration: 'none',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                    backgroundColor: 'white',
                                                    width: '130px',
                                                    color: 'red'
                                                },
                                                root: {
                                                    width: '130px'
                                                }
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Tooltip label={field.value} withArrow position="top" transition="pop">
                                        <div style={{ display: 'flex', gap: '0.5rem', cursor: 'pointer' }}>
                                            <strong>{field.label}:</strong>
                                            <Badge
                                                color='white'
                                                style={{
                                                    color: 'red',
                                                    fontSize: '9.5px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    borderRadius: '5px'
                                                }}
                                                size="lg"
                                                radius="xs"
                                            >
                                                {field.value}
                                            </Badge>
                                        </div>
                                    </Tooltip>
                                )}
                            </div>
                        ))}
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                        {buttonArr?.map((button, idx) => (
                            <B2BButton
                                key={idx}
                                name={button?.name}
                                color={button?.color}
                                variant={button?.variant}
                                style={button?.style}
                                onClick={button?.onClick}
                                disabled={button?.disabled}
                            />
                        ))}
                    </div>
                </div>
            </Grid>
        </div>
    );
};

export default SalesHeader;